/* eslint-disable @typescript-eslint/no-explicit-any */

'use client';

import '@/styles/pdp.css';

import { IInventory } from '@lamesarv-sdk/types';

import { DetailsContent } from './DetailsContent';
import { DetailsHeader } from './DetailsHeader';
import { DetailsImages } from './DetailsImages';
import { DetailsNavbar } from './DetailsNavbar';
import { DetailsSimilarRVs } from './DetailsSimilarRV';

export interface IInventoryDetailsProps {
  item: IInventory;
  defaultImageBackground?: string | null;
  locationsOptionSet?: any;
}

export const InventoryDetails = (props: IInventoryDetailsProps) => (
  <div className="flex flex-col">
    <DetailsHeader item={props.item} />
    <DetailsImages item={props.item} defaultImageBackground={props.defaultImageBackground} />
    <div className="flex flex-col order-4">
      <DetailsNavbar item={props.item} />
      <DetailsContent item={props.item} locationsOptionSet={props.locationsOptionSet} />
      <DetailsSimilarRVs item={props.item} />
    </div>
  </div>
);
